import React, { useState, useCallback } from "react";

const AuthContext = React.createContext({
  token: "",
  isLoggedIn: false,
  email: "",
  name: "",
  picture: "",
  admin: "",
  login: (token) => {},
  logout: () => {},
  cronicleId: 0,
});

export const AuthContextProvider = (props) => {
  const [token, setToken] = useState(null);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [admin, setAdmin] = useState("");
  const [picture, setPicture] = useState("");
  
  const userIsLoggedIn = !!token;

  const logoutHandler = useCallback(() => {
    setToken(null);
    setEmail("");
    setName("");
    setAdmin("");
    setPicture("");
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    localStorage.removeItem("admin");
    localStorage.removeItem("picture");
  }, []);

  const loginHandler = (token, email, name, admin, picture) => {
    setToken(token);
    setEmail(email);
    setName(name);
    setAdmin(admin);
    setPicture(picture);
    localStorage.setItem("token", token);
    localStorage.setItem("email", email);
    localStorage.setItem("name", name);
    localStorage.setItem("admin", admin);
    localStorage.setItem("picture", picture);
  };

  const contextValue = {
    token: token,
    isLoggedIn: userIsLoggedIn,
    email: email,
    name: name,
    admin: admin,
    picture: picture,
    login: loginHandler,
    logout: logoutHandler,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;